

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M11.1185 8.44493V7.46481L6.87152 4.33183C6.88448 3.50611 6.88342 2.67083 6.85735 1.81922C6.80984 0.813054 6.42013 0 5.99996 0C5.57994 0 5.19023 0.813054 5.14274 1.81922C5.11669 2.67083 5.11561 3.50613 5.12857 4.33183L0.881409 7.46483V8.44495L5.19785 6.66702C5.25205 7.99194 5.31831 9.3048 5.36598 10.6251L4.0519 11.3528V12L5.99996 11.6602L7.94791 12V11.3528L6.63413 10.6251C6.68162 9.3048 6.74772 7.99194 6.80226 6.66702L11.1185 8.44493Z","fill":"#342245"}, []), "\n"]);
};

        